import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { LightUserModel } from '../../../shared/data/models/light-user.model';
import { FollowUnFollowUserInput } from '../../../shared/data/inputs/follow-un-follow-user.input';
import { LightUserStateModel } from '../../state/states/light-user-state.model';

@Component({
  selector: 'anms-connection-user',
  templateUrl: './connection-user.component.html',
  styleUrls: ['./connection-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ConnectionUserComponent implements OnInit {
  @Input() userState: LightUserStateModel;
  @Input() currentUser: LightUserModel;

  @Output() followUser = new EventEmitter<FollowUnFollowUserInput>();
  @Output() unFollowUser = new EventEmitter<FollowUnFollowUserInput>();

  constructor() {}

  ngOnInit(): void {}

  followUserAction(): void {
    this.followUser.emit({
      followeeId: this.userState.user.ID
    });
  }

  unFollowUserAction(): void {
    this.unFollowUser.emit({
      followeeId: this.userState.user.ID
    });
  }
}
